// removed by extract-text-webpack-plugin
module.exports = {"numberInfo":"numberInfo___1MMKa","suffix":"suffix___1s4AO","subTotal":"subTotal___32JPp","numberInfolight":"numberInfolight___2OziR"};


//////////////////
// WEBPACK FOOTER
// /Applications/MAMP/htdocs/www/alipay-cd/project/antd-pro/antd-pro/scaffold/src/components/Charts/NumberInfo/index.less
// module id = 425
// module chunks = 0 1